var React = require('react');

function IconChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.5 12L15 4.5l1.05 1.05L9.6 12l6.45 6.45L15 19.5 7.5 12z"}));
}

IconChevronLeft.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 24 24"};

module.exports = IconChevronLeft;

IconChevronLeft.default = IconChevronLeft;
